"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DeleteBucketWebsiteInput_1 = require("./DeleteBucketWebsiteInput");
var DeleteBucketWebsiteOutput_1 = require("./DeleteBucketWebsiteOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.DeleteBucketWebsite = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "DeleteBucketWebsite",
    http: {
        method: "DELETE",
        requestUri: "/{Bucket}?website"
    },
    input: {
        shape: DeleteBucketWebsiteInput_1.DeleteBucketWebsiteInput
    },
    output: {
        shape: DeleteBucketWebsiteOutput_1.DeleteBucketWebsiteOutput
    },
    errors: []
};
//# sourceMappingURL=DeleteBucketWebsite.js.map